module.exports = __webpack_public_path__ + "img/office_depot.e8e81c20.png";